export const dataHooks = {
    provider: 'dnd-provider',
};
//# sourceMappingURL=constants.js.map